<template>
  <v-card>
    <v-divider></v-divider>
    <v-card-title primary-title>
      <div>
        <h5 class="title mb-0">Recebimento na empresa (Pós-Pago)</h5>
      </div>
    </v-card-title>
    <v-divider></v-divider>
    <v-flex>
      <v-data-table
        :headers="headers"
        :items="itemsToShow"
        :hide-default-header="!itemsToShow.length"
        hide-default-footer
        :loading="isLoading"
        class="elevation-1"
      >
        <template v-slot:item="props">
          <tr :key="props.item.id_tipo_pagamento">
            <td style="width: 10px">
              <v-switch
                color="success"
                :input-value="props.item.aceito"
                @change="val => onToggle(props.item, val)"
              />
            </td>
            <td class="text-xs-left">{{ props.item.descricao }}</td>
          </tr>
        </template>

        <template v-slot:no-data>
          <v-layout justify-center class="pa-4 grey--text">
            Nenhum método pós-pago configurado.
          </v-layout>
        </template>
      </v-data-table>
    </v-flex>
  </v-card>
</template>

<script>
export default {
  name: 'SelectMetodosPospago',
  data () {
    return {
      headers: [
        { text: '', value: 'toggle', sortable: false, align: 'left', width: 10 },
        { text: 'Descrição', value: 'descricao', sortable: false, align: 'left' }
      ],
      aceitos: {},
      listaTiposEmpresa: []
    }
  },
  computed: {
    isLoading () {
      return this.loading || this.$store.getters.loading
    },
    tiposPagamentoStore () {
      return this.$store.getters.tipos_pagamento || []
    },
    empresa () {
      return this.$store.getters.empresa
    },
    itemsToShow () {
      const base = (this.tiposPagamentoPos && this.tiposPagamentoPos.length)
        ? this.tiposPagamentoPos
        : this.tiposPagamentoStore
      const mapEmpresa = {}
      this.listaTiposEmpresa.forEach(t => {
        if (!t) return
        if (t.id_tipo_pagamento != null) mapEmpresa[t.id_tipo_pagamento] = !!t.aceito
        if (t.referencia != null) mapEmpresa[t.referencia] = !!t.aceito
      })
      const final = base.map(b => {
        const id = b.id_tipo_pagamento != null ? b.id_tipo_pagamento : (b.id != null ? b.id : null)
        const ref = b.referencia || null
        let aceito = false
        if (id != null && mapEmpresa[id] !== undefined) aceito = mapEmpresa[id]
        else if (ref != null && mapEmpresa[ref] !== undefined) aceito = mapEmpresa[ref]
        else if (id != null && this.aceitos[id] !== undefined) aceito = !!this.aceitos[id]
        else if (ref != null && this.aceitos[ref] !== undefined) aceito = !!this.aceitos[ref]
        else aceito = false

        return {
          id_tipo_pagamento: id,
          descricao: b.descricao,
          referencia: ref,
          aceito
        }
      })
      this.ensureAceitos(final)
      return final
    }
  },
  methods: {
    ensureAceitos (lista) {
      if (!Array.isArray(lista)) return
      lista.forEach(item => {
        const id = item.id_tipo_pagamento
        const ref = item.referencia
        const chave = id != null ? id : ref
        if (chave == null) return
        if (this.aceitos[chave] === undefined) {
          const valor = item.aceito !== undefined
            ? !!item.aceito
            : (id != null ? !!this.valores[id] : !!this.valores[ref])
          this.$set(this.aceitos, chave, valor)
        }
      })
    },
    onToggle (item, value) {
      const id = item.id_tipo_pagamento
      const ref = item.referencia
      const chave = id != null ? id : ref
      this.$set(this.aceitos, chave, !!value)
      this.$emit('toggle', {
        id_tipo_pagamento: id,
        referencia: ref,
        value: !!value
      })
      if (this.empresa && ref) {
        this.$store.dispatch('permitirTipoPagamentoPosPago', { empresa: this.empresa.cnpj, referencia: ref })
          .then(() => {
            this.loadEmpresaTipos()
          })
          .catch(() => {
            this.$set(this.aceitos, chave, !value)
          })
      }
    },
    carregarTiposGerais () {
      this.$store.dispatch('carregarTiposPagamento').catch(() => {})
    },
    loadEmpresaTipos () {
      if (!this.empresa) return
      this.$store.dispatch('tipospagamentoEmpresa', this.empresa.cnpj)
        .then(lista => {
          const arr = Array.isArray(lista) ? lista : []
          this.listaTiposEmpresa = arr.map(item => {
            const tp = item.tipo_pagamento || {}
            const idTipo = tp.id_tipo_pagamento != null ? tp.id_tipo_pagamento : (item.id != null ? item.id : null)
            const referencia = tp.referencia || item.referencia || null
            const aceito = idTipo != null
            const chaveId = idTipo != null ? idTipo : null
            if (chaveId != null) this.$set(this.aceitos, chaveId, !!aceito)
            if (referencia != null) this.$set(this.aceitos, referencia, !!aceito)
            return { id_tipo_pagamento: idTipo, referencia, aceito }
          })
        })
        .catch(() => {})
    }
  },
  created () {
    this.carregarTiposGerais()
    this.loadEmpresaTipos()
  },
  watch: {
    tiposPagamentoStore (nv) {
      this.ensureAceitos(nv)
    },
    tiposPagamentoPos (nv) {
      this.ensureAceitos(nv)
    },
    empresa (val) {
      if (val) {
        this.loadEmpresaTipos()
      }
    },
    valores: {
      handler (nv) {
        Object.keys(nv || {}).forEach(k => {
          this.$set(this.aceitos, Number(k), !!nv[k])
        })
      },
      deep: true
    }
  }
}
</script>
